import clsx from 'clsx'
import {HTMLProps} from 'react'

export interface ListItemProps extends HTMLProps<HTMLLIElement> {
  /**
   * React component displayed as an avatar or icon on the list item.
   */
  avatar?: React.ReactNode
}

export function ListItem({
  avatar,
  children,
  className,
  onClick,
  onKeyDown,
  role,
  tabIndex,
  ...props
}: ListItemProps) {
  return (
    <li
      className={clsx(
        'grid items-center',
        !className?.includes('grid-flow-row') && 'grid-flow-col gap-3',
        onClick &&
          'text-primary hover:text-primary-light hover:underline text-lg transition-colors',
        className,
      )}
      onClick={onClick}
      onKeyDown={onKeyDown}
      role={onClick ? 'button' : role}
      tabIndex={onClick ? 0 : tabIndex}
      {...props}
    >
      {avatar && (
        <div className="w-11 h-11 rounded-full text-white bg-primary flex items-center justify-center">
          {avatar}
        </div>
      )}

      {children}
    </li>
  )
}

export default ListItem
